import { render, staticRenderFns } from "./reject-modal.vue?vue&type=template&id=1474e0ad&scoped=true&"
import script from "./reject-modal.vue?vue&type=script&lang=js&"
export * from "./reject-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1474e0ad",
  null
  
)

export default component.exports